module.exports = "pegasus_template/assets/presentation_bg_2.png";